<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      title="领取发票"
      :visible="dialogVisible"
      width="500px"
      @close="handleClose"
      append-to-body
      center
    >
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="发票类别">
          <el-radio-group v-model="form.resource">
            <el-radio label="电子发票"></el-radio>
            <el-radio label="纸质发票"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model="form.number"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from "@/minxs/showdialog";
export default {
  data() {
    return {
      form: {
        resource: "电子发票",
        name: "",
        number: "",
        mobile: "",
      },
    };
  },
  mixins: [showdialog],
  methods: {
    handleClick() {
      // console.log(this.form);
    },
  },
};
</script>
